/**
 * English locale — SECONDARY.
 */
const en = {
  brand: "Azuris Gemological Research",
  tagline: "Gemstone certification, identity documentation, and verification.",
  comingSoon: "This page will be implemented in a future stage.",
  sprintNotice: "A Trusted Gemological Institution",
  breadcrumbHome: "Home",
  nav: {
    home: "Home",
    verification: "Verify Certificate",
    process: "Certification Process",
    legality: "Legality",
    about: "About Azuris",
    contact: "Contact Us",
    login: "Sign In",
    catalog: "Catalog",
    gemstones: "Gemstones",
    jewelry: "Jewelry",
  },
  footer: {
    rights: "All rights reserved.",
    established: "A Trusted Gemological Institution",
    tagline2: "Certification · Documentation · Verification",
  },
  home: {
    established: "A Trusted Gemological Institution",
    slides: {
      pillars: {
        eyebrow: "Four Pillars",
        title: "The Four Pillars of Gemstones",
        subtitle:
          "Understanding the key characters of gemstones that form an essential part of gemology.",
        ctaPrimary: "Verify Certificate",
        ctaSecondary: "Learn the Certification Process",
        items: {
          diamond: "Diamond",
          ruby: "Ruby",
          sapphire: "Sapphire",
          emerald: "Emerald",
        },
      },
      diamondRuby: {
        eyebrow: "Gemstone Identity",
        title: "Diamond & Ruby",
        diamond: {
          name: "Diamond",
          desc: "The hardest stone on earth, renowned for its brilliance and clarity.",
        },
        ruby: {
          name: "Ruby",
          desc: "A vivid red gemstone symbolizing strength and passion.",
        },
      },
      sapphireEmerald: {
        eyebrow: "Gemstone Identity",
        title: "Sapphire & Emerald",
        sapphire: {
          name: "Sapphire",
          desc: "A precious stone commonly known for its elegant deep blue color.",
        },
        emerald: {
          name: "Emerald",
          desc: "A gemstone with a distinctive, iconic green color.",
        },
      },
    },
    promo: {
      eyebrow: "SPECIAL INFORMATION",
      heading: "Professional Gemstone Certification",
      desc: "Contact Azuris Gemological Research for examination schedules and further information.",
      cta: "MORE INFORMATION",
    },
  },
  verify: {
    eyebrow: "Authenticity Verification",
    title: "Verify Certificate",
    description:
      "Enter the certificate number printed on your Azuris document to check its authenticity.",
    certLabel: "Certificate Number",
    certPlaceholder: "AGR-ZMD-000015-26",
    codeLabel: "Security Code",
    codePlaceholder: "Code on the certificate",
    submit: "Verify",
    submitting: "Checking…",
    formatError: "Certificate not found.",
    codeRequired: "Security code is required.",
    notFound: "Certificate not found.",
    authentic: "This certificate is authentic and issued by Azuris Gemological Research (AGR).",
    coverHeading: "Certificate Cover",
    viewDetails: "View Certificate Details",
    pdfTitle: "4-Page Certificate",
    close: "Close",
    unavailableTitle: "Verification Service Is Being Prepared",
    unavailable:
      "The verification service is being prepared. No certificate data is shown before the verification system is active.",
    emptyHint:
      "Every Azuris certificate has a unique number and can be verified digitally.",
  },
  process: {
    eyebrow: "Workflow",
    title: "Certification Process",
    subtitle:
      "Every stone goes through a documented and verifiable examination workflow.",
    steps: {
      register: {
        title: "Stone Registration",
        desc: "Initial data recording and intake of the stone for examination.",
      },
      examine: {
        title: "Physical & Gemological Examination",
        desc: "Physical and gemological analysis to identify the stone's characteristics.",
      },
      document: {
        title: "Result Documentation",
        desc: "Detailed and structured recording of examination results.",
      },
      issue: {
        title: "Certificate Issuance",
        desc: "Issuance of a certificate with a unique, verifiable number.",
      },
      verify: {
        title: "Digital Verification",
        desc: "Checking certificate authenticity through the digital verification system.",
      },
    },
  },
  why: {
    eyebrow: "Advantages",
    title: "Why Choose Azuris",
    subtitle:
      "Our focus is professional gemstone examination, documentation, and verification.",
    items: {
      examination: {
        title: "Gemological Examination",
        desc: "Thorough and objective gemological examination.",
      },
      documentation: {
        title: "Identity Documentation",
        desc: "Complete and consistent gemstone identity documentation.",
      },
      verification: {
        title: "Authenticity Verification",
        desc: "Verify certificate authenticity anytime, digitally.",
      },
      integrity: {
        title: "Document Integrity",
        desc: "Document integrity protection and data transparency.",
      },
    },
  },
  standards: {
    eyebrow: "Standards",
    title: "Examination Standards",
    subtitle: "Every stone is examined against the key gemological aspects.",
    items: {
      species: {
        title: "Species & Variety Identification",
        desc: "Determining the stone's type and variety through gemological analysis.",
      },
      color: {
        title: "Color & Clarity Characteristics",
        desc: "Assessment of color, transparency, and clarity characteristics.",
      },
      treatment: {
        title: "Treatment Indication",
        desc: "Identification of any treatment indications on the stone.",
      },
      photo: {
        title: "Photographic Documentation",
        desc: "Visual documentation as part of the examination report.",
      },
    },
  },
  legalityTeaser: {
    eyebrow: "Credibility",
    title: "Legality and Credibility",
    body: "Azuris Gemological is committed to professional and verifiable gemstone examination, identification, documentation, and certification services.",
    cta: "View Legality",
  },
  contact: {
    eyebrow: "Contact Us",
    title: "Contact Azuris",
    subtitle:
      "Reach the Azuris team for questions about gemstone examination, certification, and verification.",
    whatsapp: "Contact via WhatsApp",
    moreInfo: "MORE INFORMATION",
  },
  homeMembership: {
    eyebrow: "Membership",
    title: "Azuris Membership",
    desc: "A digital membership identity linked to owner records and verifiable through the Azuris system.",
    cta: "Verify Membership",
  },
  legality: {
    title: "Azuris Gemological Legality",
    subtitle:
      "A commitment to professional and verifiable gemstone examination, identification, and certificate issuance.",
    ctaVerify: "Verify a Gemstone Certificate",
    viewerTitle: "Legality Document",
    emptyTitle: "Document Not Yet Published",
    empty:
      "The official legality document has not been published yet. Information will appear here once available and validated by Azuris Gemological.",
    copyTitle: "Our Commitment",
    copy: "This certificate represents Azuris Gemological's commitment to providing professional gemstone examination, identification, documentation, and certification services. Every gemstone certificate issued by Azuris has a unique number and can be verified through the digital verification system.",
    disclaimerTitle: "Disclaimer",
    disclaimer:
      "A gemological certificate is a report of gemstone examination and identification. It does not automatically guarantee price, investment value, ownership, or the legal origin of a gemstone.",
  },
  verifyResult: {
    validTitle: "Certificate Verified",
    valid: "This certificate is authentic and active.",
    archivedTitle: "Certificate Archived",
    archived: "This certificate version has been archived.",
    revokedTitle: "Certificate Revoked",
    revoked: "This certificate has been revoked and is no longer valid.",
    expiredTitle: "Certificate Expired",
    expired: "This certificate has expired.",
    notFoundTitle: "Unable to Verify",
    notFound: "The certificate number and security code could not be verified.",
    errorTitle: "Something Went Wrong",
    error: "Unable to process verification right now. Please try again.",
    showDetails: "Show Details",
    qrDetected: "QR code detected. Press Show Details to verify.",
    certificatePreview: "Certificate Preview",
    verifiedCertificate: "Verified Certificate",
    viewDigitalCertificate: "View Digital Certificate",
    previewUnavailable: "Certificate preview is unavailable",
    sectionBasic: "Certificate Information",
    sectionGemstone: "Gemstone Identity",
    sectionResult: "Examination Result",
    sectionOwner: "Owner",
    fields: {
      number: "Certificate Number", version: "Version", issue: "Issue Date",
      owner: "Owner", species: "Species", carat: "Weight", color: "Color",
      clarity: "Clarity", cut: "Cut", shape: "Shape", origin: "Origin",
      treatment: "Treatment", conclusion: "Conclusion",
    },
  },
  auth: {
    subtitle: "Sign in to the Azuris admin panel.",
    email: "Email", password: "Password",
    signIn: "Sign In", signingIn: "Signing in…",
    error: "Invalid email or password.", logout: "Sign Out",
  },
  adminNav: { legality: "Legality", settings: "Settings", customers: "Customers", gemstones: "Gemstones", jewelry: "Jewelry", warranties: "Warranties", ownership: "Ownership", membership: "Membership" },
  adminLegality: {
    title: "Manage Legality",
    subtitle: "Manage the official Azuris legality document shown publicly.",
    create: "Add Credential", name: "Certificate Name", holder: "Holder / Institution",
    number: "Certificate Number", issuer: "Issuer", issueDate: "Issue Date",
    expiry: "Expiry Date", status: "Status", description: "Short Description",
    download: "Allow public download", document: "Certificate Document", upload: "Upload Document",
    save: "Save", publish: "Publish", unpublish: "Unpublish", delete: "Delete",
    published: "Published", draft: "Draft", empty: "No legality credential yet.",
    saved: "Saved.", uploaded: "Document uploaded.",
    signatoryName: "Authorized Signatory Name", signatoryPosition: "Position / Title",
    activeForCerts: "Active for New Certificates", activeBadge: "Active for Certificates",
    signature: "Signature Image", uploadSignature: "Upload Signature", replaceSignature: "Replace Signature",
    removeSignature: "Remove Signature", signaturePreview: "Signature Preview",
    signatureHint: "PNG with transparent background preferred (JPG/WebP also accepted, max 5MB).",
    signatureUploaded: "Signature uploaded.", signatureRemoved: "Signature removed.",
    saveFirst: "Save the credential first, then upload a signature.",
  },
  adminSettings: {
    title: "Contact Settings",
    subtitle: "The business WhatsApp number used by all public contact buttons.",
    whatsapp: "Business WhatsApp Number", label: "Label (optional)", enabled: "Enable WhatsApp",
    save: "Save Changes", saved: "Changes saved.",
    hint: "Example: 087812128884 or +62 878-1212-8884",
    invalid: "Invalid WhatsApp number.",
  },
  adminVisuals: {
    navTitle: "Visuals & Content",
    title: "CMS Visual Controls",
    subtitle: "Manage public visuals: admin login image, certification process image, and the homepage membership section.",
    loginSection: "Admin Login Image",
    processSection: "Certification Process Image",
    membershipSection: "Homepage Membership",
    imageUrl: "Image URL (Media Library / asset)",
    altId: "Alt text (ID)", altEn: "Alt text (EN)",
    show: "Show section", preview: "Preview",
    titleId: "Title (ID)", titleEn: "Title (EN)",
    descId: "Description (ID)", descEn: "Description (EN)",
    ctaId: "CTA text (ID)", ctaEn: "CTA text (EN)", link: "Target Link",
    save: "Save Visuals", saved: "Visuals saved.",
    readOnly: "You have read-only access to these controls.",
    uploadBtn: "Upload Image",
    pickBtn: "Choose from Media",
    change: "Change",
    reset: "Reset Default",
    advancedUrl: "URL / Asset (advanced)",
    uploading: "Uploading…",
    pickerTitle: "Choose an Image from Media",
    pickerEmpty: "No images yet. Upload an image first.",
    invalidType: "Unsupported format. Use JPG, PNG, or WebP.",
    uploadFailed: "Upload failed. Please try again.",
    close: "Close",
    dashboardSection: "Dashboard Background",
    dashboardHint: "Set the admin panel background. Disabled = uses the default Azuris marble.",
    bgEnabled: "Enable custom background",
    bgOpacity: "Intensity / Opacity",
    bgFit: "Image Fit",
    fitCover: "Fill (Cover)",
    fitCenter: "Center",
    bgBlur: "Blur",
    resetMarble: "Reset to Default Marble Background",
    loginSectionBg: "Login Page Background",
    loginBgHint: "Set the admin login page background to match the dashboard.",
    resetLoginBg: "Reset Login Background",
    homeBgSection: "Homepage Background",
    homeBgHint: "Set the homepage hero background image. Disabled = uses the default Azuris marble.",
    resetHomeBg: "Reset to Default Background",
    homeGemsSection: "Homepage Gemstone Photos",
    homeGemsHint: "Replace the gemstone photos shown in the homepage hero (Diamond, Ruby, Sapphire, Emerald).",
    gemDiamond: "Diamond",
    gemRuby: "Ruby",
    gemSapphire: "Sapphire",
    gemEmerald: "Emerald",
    promoSection: "Homepage Promotional Slide",
    promoHint: "The promotional slide appears first in the homepage hero. Leave text empty to use the default message.",
    promoImage: "Promotional Image (optional)",
    promoEyebrowId: "Eyebrow (ID)", promoEyebrowEn: "Eyebrow (EN)",
    promoHeadingId: "Heading (ID)", promoHeadingEn: "Heading (EN)",
    promoDescId: "Description (ID)", promoDescEn: "Description (EN)",
    promoCtaId: "CTA Text (ID)", promoCtaEn: "CTA Text (EN)",
  },
  adminCert: {
    navTitle: "Certificates",
    title: "Certificate Issuance",
    subtitle: "Create a gemstone record, issue a certificate, then generate the QR and A6 PDF.",
    newGem: "New Gemstone Record",
    gemNameId: "Gemstone Name (ID)", gemName: "Gemstone Name (EN)", category: "Category",
    type: "Species / Type", carat: "Weight (ct)", color: "Color", clarity: "Clarity",
    cut: "Cut", shape: "Shape", dimensions: "Dimensions (mm)", origin: "Origin", treatment: "Treatment",
    kodeBatu: "Gemstone Code",
    kodeBatuHelper: "Enter exactly three letters, for example EMD for Emerald.",
    kodeBatuError: "Gemstone code must contain exactly three letters.",
    kodeBatuRequired: "Gemstone code is required",
    sampleCard: "Sample Card",
    createGem: "Save Gemstone", uploadPhoto: "Upload Photo", issue: "Issue Certificate",
    examiner: "Examiner", conclusion: "Identification Conclusion",
    issued: "Certificate issued.",
    securityCodeNote: "Save this security code — shown only once:",
    qrNote: "QR URL:", gemstones: "Registered Gemstones", certificates: "Certificates",
    pdf: "Download PDF", card: "Card", revoke: "Revoke", revoked: "Revoked.",
    noGem: "No gemstones yet.", issuedBadge: "Certified",
    demoPreview: "Preview Sample Certificate",
    demoTitle: "Sample Certificate (Demo Preview)",
    demoNote: "Design preview only. Not a genuine certificate — nothing is saved, verified, or affects numbering.",
    demoOpenPdf: "Open PDF",
    demoClose: "Close",
  },
  adminCustomers: {
    title: "Customers", subtitle: "Manage gemstone owner records. Contact data is never shown publicly.",
    search: "Search name, email, phone…", add: "Add Customer", edit: "Edit", save: "Save", cancel: "Cancel", delete: "Delete",
    fullName: "Full Name", email: "Email", phone: "Phone", address: "Address", notes: "Notes",
    consent: "Privacy consent recorded", consentAt: "Consent at", empty: "No customers yet.",
    confirmDelete: "Delete this customer?",
  },
  adminGemstones: {
    title: "Gemstones", subtitle: "Manage the gemstone catalog — status, media and search.",
    search: "Search name, type, origin…", add: "Add Gemstone", edit: "Edit", save: "Save", cancel: "Cancel", delete: "Delete",
    nameId: "Name (ID)", nameEn: "Name (EN)", category: "Category", type: "Species / Type", carat: "Weight (ct)",
    color: "Color", clarity: "Clarity", cut: "Cut", shape: "Shape", dimensions: "Dimensions (mm)", origin: "Origin", treatment: "Treatment",
    status: "Status", allStatus: "All statuses", media: "Media", uploadMedia: "Upload Media", setMain: "Set Main",
    empty: "No gemstones yet.", confirmDelete: "Delete this gemstone?", hasCert: "Certified — cannot delete", updateStatus: "Update Status",
  },
  adminJewelry: {
    title: "Jewelry", subtitle: "Manage jewelry pieces composed of one or more gemstones.",
    search: "Search name, type, material…", add: "Add Jewelry", edit: "Edit", save: "Save", cancel: "Cancel", delete: "Delete",
    nameId: "Name (ID)", nameEn: "Name (EN)", type: "Jewelry Type", material: "Material", weight: "Weight (g)",
    dimensions: "Dimensions (mm)", gemstones: "Linked Gemstones", status: "Status", allStatus: "All statuses",
    empty: "No jewelry yet.", confirmDelete: "Delete this jewelry?", noGems: "No gemstones to select.", updateStatus: "Update Status",
  },
  adminWarranty: {
    title: "Warranties", subtitle: "Manage per-gemstone warranties — coverage period, status and versioning.",
    add: "Add Warranty", reissue: "Reissue", save: "Save", cancel: "Cancel", delete: "Delete",
    gemstone: "Gemstone UUID", termsId: "Terms (ID)", termsEn: "Terms (EN)",
    period: "Period (months)", startDate: "Start Date", endDate: "End Date",
    number: "Warranty No.", status: "Status", version: "Version", allStatus: "All statuses",
    setVoid: "Void", setExpired: "Mark Expired", empty: "No warranties yet.",
    confirmDelete: "Delete this warranty?", filterGem: "Filter gemstone UUID",
  },
  adminOwnership: {
    title: "Ownership", subtitle: "Authoritative customer ↔ gemstone ownership. Ownership only changes through the transfer workflow.",
    gemLabel: "Gemstone UUID", load: "Load", currentOwner: "Current Owner", noOwner: "No owner yet.",
    gemStatus: "Gemstone Status", assign: "Assign Initial Owner", owner: "Owner", selectCustomer: "Select customer…",
    newTransfer: "New Transfer", recipient: "Recipient", create: "Create Transfer", pending: "Pending Transfer",
    complete: "Complete", cancel: "Cancel", history: "Ownership History", noHistory: "No history yet.",
    codeNote: "New security code (shown once):", masked: "Masked name", from: "From", to: "To",
    notFound: "Gemstone not found.",
  },
  adminMembership: {
    title: "Membership Cards", subtitle: "Premium Azuris member identity cards. Masked identity only — no private data.",
    add: "Issue Card", customer: "Customer", selectCustomer: "Select customer (with consent)…",
    create: "Issue", cancel: "Cancel", memberId: "Member ID", memberName: "Member Name", memberSince: "Member Since",
    status: "Status", version: "Version", activate: "Activate", deactivate: "Deactivate", reissue: "Reissue",
    delete: "Delete", viewCard: "View Card", empty: "No membership cards yet.", confirmDelete: "Delete this card?",
    cardTitle: "MEMBERSHIP CARD", statement: "Verified Azuris Gemological member.", scan: "Scan to verify membership.",
    close: "Close", front: "Front", back: "Back",
  },
  membershipVerify: {
    title: "Membership Verification", checking: "Checking…",
    valid: "Azuris Membership Active", inactive: "Membership Inactive", invalid: "Card could not be verified.",
    memberId: "Member ID", memberName: "Member Name", memberSince: "Member Since", status: "Status",
  },
  admin: {
    title: "Admin Panel",
    dashboard: "Dashboard",
    dash: {
      eyebrow: "Operational Overview",
      subtitle: "An aggregated, privacy-safe summary of platform activity.",
      refresh: "Refresh",
      loading: "Loading analytics…",
      error: "Failed to load analytics.",
      records: "Total Records",
      certificates: "Certificates",
      verifications: "Verifications (30d)",
      customers: "Customers",
      gemstones: "Gemstones",
      jewelry: "Jewelry",
      warranties: "Warranties",
      transfers: "Ownership Transfers",
      memberships: "Membership Cards",
      media: "Media",
      verifyTrend: "Verification Trend (14 days)",
      verifyTotal: "Total Verifications",
      verifySuccess: "Successful",
      byStatus: "Status Breakdown",
      gemStatus: "Gemstone Status",
      certStatus: "Certificate Status",
      warrantyStatus: "Warranty Status",
      transferStatus: "Transfer Status",
      membershipStatus: "Membership Status",
      verifyResults: "Verification Results (30d)",
      adminActivity: "Admin Activity (30d)",
      counter: "Certificate Numbering",
      nextCertificate: "Next Certificate Number",
      lastNumber: "Last Number",
      noData: "No data yet.",
      generatedAt: "Updated",
    },
  },
  language: {
    label: "Language",
    id: "Indonesian",
    en: "English",
  },
} as const;

export default en;
